import { useEffect, useState } from 'react';

type CertificateData = {
	path: string;
	title: string;
	description: string;
};

const completedCourseCertificate: CertificateData = {
	path: 'web-assets/CertificateEnabled.png',
	title: 'web-le.earned-certificate-title',
	description: 'web-le.earned-certificate-description',
};

const incompleteCourseCertificate: CertificateData = {
	path: 'web-assets/CertificateDisabled.png',
	title: 'web-le.certificate-title',
	description: 'web-le.certificate-description',
};

export const useCourseComplete = (onComplete: () => void) => {
	const [isCourseCompleted, setIsCourseCompleted] = useState<boolean>(false);
	const [data, setData] = useState<CertificateData>(
		incompleteCourseCertificate,
	);

	useEffect(() => {
		setData(
			isCourseCompleted
				? completedCourseCertificate
				: incompleteCourseCertificate,
		);
		if (isCourseCompleted) {
			onComplete();
		}
	}, [isCourseCompleted]);

	return {
		isCourseCompleted,
		setIsCourseCompleted,
		data,
	};
};
